var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExhibitions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16a3 3 0 100-6 3 3 0 000 6zm0-2a1 1 0 100-2 1 1 0 000 2z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.414 7L12 2.586 7.586 7H2v13h20V7h-5.586zm-2.828 0L12 5.414 10.414 7h3.172zM4 9h16v9h-5.586L7 10.586l-3 3V9zm0 7.414V18h7.586L7 13.414l-3 3z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExhibitions);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIj4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE2IDE2LjAwMDFDMTcuNjU2OSAxNi4wMDAxIDE5IDE0LjY1NyAxOSAxMy4wMDAxQzE5IDExLjM0MzMgMTcuNjU2OSAxMC4wMDAxIDE2IDEwLjAwMDFDMTQuMzQzMSAxMC4wMDAxIDEzIDExLjM0MzMgMTMgMTMuMDAwMUMxMyAxNC42NTcgMTQuMzQzMSAxNi4wMDAxIDE2IDE2LjAwMDFaTTE2IDE0LjAwMDFDMTYuNTUyMyAxNC4wMDAxIDE3IDEzLjU1MjQgMTcgMTMuMDAwMUMxNyAxMi40NDc4IDE2LjU1MjMgMTIuMDAwMSAxNiAxMi4wMDAxQzE1LjQ0NzcgMTIuMDAwMSAxNSAxMi40NDc4IDE1IDEzLjAwMDFDMTUgMTMuNTUyNCAxNS40NDc3IDE0LjAwMDEgMTYgMTQuMDAwMVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgogIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTYuNDE0MyA3LjAwMDEyTDEyLjAwMDEgMi41ODU5NEw3LjU4NTg5IDcuMDAwMTJIMlYyMC4wMDAxSDIyVjcuMDAwMTJIMTYuNDE0M1pNMTMuNTg1OCA3LjAwMDEyTDEyLjAwMDEgNS40MTQzNkwxMC40MTQzIDcuMDAwMTJIMTMuNTg1OFpNNCA5LjAwMDEySDIwVjE4LjAwMDFIMTQuNDE0M0w3LjAwMDA4IDEwLjU4NTlMNCAxMy41ODZWOS4wMDAxMlpNNCAxNi40MTQ0VjE4LjAwMDFIMTEuNTg1OEw3LjAwMDA4IDEzLjQxNDRMNCAxNi40MTQ0WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPg==";
export { ForwardRef as ReactComponent };